import { useDispatch, useSelector } from "react-redux";
import useGarbageCollector from "../../../../../libs/garbagecollector/garbageCollectorHooks";
import commonStyles from "../../FormSection.styles";
import styles from "./StateResubmit.styles";
import Loadable from "../../../../components/loadable/Loadable";
import SelectDropdown from "../../../../components/dropdown/selectdropdown/SelectDropdown";
import { QUERY_PARAMS } from "../../constants";
import Button from "../../../../components/button/Button";
import RichGrid from "../../../../components/richgrid/RichGrid";
import { ROW_SELECTION_OPTIONS } from "../../../../components/richgrid/constants";
import { componentKey, setDownloadAllPdfModal, setPaginationState, setPayerList, setReloadResubmitGridData, setSelectedForm, setSelectedPayer, setSelectedStateReference, setSelectedStateResubmitGridData, setSelectedTaxYear, setUpdateWithheldIdModal, setWithheldIdText, setPayerDropdownPagination } from "./StateResubmitSlice";
import Label from "../../../../components/label/Label";
import { LABEL_WEIGHT } from "../../../../components/label/constants";
import Payer from "../../../../../libs/utility/Payer";
import { useEffect, useState } from "react";
import { downLoadStatePDFs, getPayersList, getStateResubmitFormsList, getStateResubmitGridData, getStateResubmitTaxYears, reSubmitSelectedFormsToState, stateResubmitViewPDF, updateStateWithHeldId } from "./StateResubmitSaga";
import { BUTTON_TYPE } from "../../../../components/button/constants";
import { addNotifications } from "../../../toaster/ToasterPortalSlice";
import Popup from "../../../../components/popup/Popup";
import TextInput from "../../../../components/input/textinput/TextInput";
import DownloadAllPdf from "../../manageforms/managestateforms/downloadallpdf/DownloadAllPdf";
import Icons from "../../../../components/icons/Icons";
import { VEC_ICON_NAME } from "../../../../components/icons/constants";
import useTxSearchParams from "../../../../../libs/txsearchparams/TxSearchParamsHook";
import { TOASTER_VARIANT } from "../../../../components/toast/constants";
import { IRS_STATE_RESUBMIT_LOADING_STATES, IRS_STATE_RESUBMIT_MESSAGE_MAP } from "../constant";
import useFormatTIN from "../../../../../libs/customhooks/useFormatTIN";
import { isAccessAllowed, useUserPermissionsInfo } from "../../../dashboard/hooks/userHooks";
import { PAGE_PERMISSIONS } from "../../../dashboard/constants/constant";
import { setShowPaymentNotAllowedPopup } from "../../../dashboard/DashboardSlice";

export default function StateResubmitForms() {

    useGarbageCollector(componentKey);

    const dispatch = useDispatch();
    const [queryParams, setQueryParams] = useTxSearchParams();
    const { permissions } = useUserPermissionsInfo();

    const { loadingState, formList, payerList, selectedForm, selectedPayer, taxYearList, selectedTaxYear, stateResubmitGridData, selectedStateResubmitGridData, paginationState, updateWithheldIdModal, withheldIdText, selectedStateReference, downloadAllPdfModal, reloadResubmitGridData, payerDropdownPagination } = useSelector(state => state[componentKey]);

    const { formatTIN } = useFormatTIN()

    const [paginatedPayerList, setPaginatedPayerList] = useState([]);
    useEffect(() => {
        setPaginatedPayerList(payerList)
    }, [payerList])

    useEffect(() => {
        dispatch(getStateResubmitFormsList({}));
        dispatch(getStateResubmitTaxYears({}));
    }, [])

    useEffect(() => {
        if (selectedForm?.value) {
            dispatch(getPayersList({ formId: selectedForm?.value }));
        } else {
            dispatch(setPayerList([]));
            dispatch(setSelectedPayer({ label: "", value: "" }))
        }
    }, [selectedForm])

    useEffect(() => {
        if (reloadResubmitGridData) {
            getGridRecords(paginationState?.PageNumber, paginationState?.PageSize);
            setReloadResubmitGridData(false);
        }
    }, [reloadResubmitGridData])

    const getGridRecords = (pageNumber, pageSize) => {
        dispatch(getStateResubmitGridData({
            formTypeId: selectedForm?.FormName1,
            formName: selectedForm?.FormName1,
            payerId: selectedPayer?.value,
            taxYear: selectedTaxYear?.value,
            PageNumber: pageNumber,
            PageSize: pageSize,
            FilterText: paginationState?.SearchByName,
            IdNumber: paginationState?.SearchByTIN,
            IsDesc: paginationState?.IsDesc
        }))
    }


    const STATE_RESUBMIT_FORMS_COLUMN = [
        {
            field: "StateReferenceNo",
            header: <Label weight={LABEL_WEIGHT[700]}>State Reference No</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row?.StateReference || "-"}</span>
        },
        {
            field: "TaxYear",
            header: <Label weight={LABEL_WEIGHT[700]}>Tax Year</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row?.TaxYear || "-"}</span>
        },
        {
            field: "TIN",
            header: <Label weight={LABEL_WEIGHT[700]}>Recipient TIN</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{formatTIN(row.TINType, row.TIN) || "-"}</span>
        },
        {
            field: "Name",
            header: <Label weight={LABEL_WEIGHT[700]}>Recipient Name</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row?.Name || "-"}</span>
        },
        {
            field: "State",
            header: <Label weight={LABEL_WEIGHT[700]}>State</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row?.State || "-"}</span>
        },
        {
            field: "Date",
            header: <Label weight={LABEL_WEIGHT[700]}>Date</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row?.Date || "-"}</span>
        },
        {
            field: "Reason",
            header: <Label weight={LABEL_WEIGHT[700]}>Rejection Reason</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row?.StateRejectionError || "-"}</span>
        },
        {
            field: "RecipientEmail",
            header: <Label weight={LABEL_WEIGHT[700]}>State withheld Account ID</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row?.AccountNumber || "-"}</span>
        },
        {
            field: "Action",
            header: <Label Label weight={LABEL_WEIGHT[700]} >Action</Label >,
            renderLogic: (row, idx) => <div style={commonStyles.actionButtons}>
                <Button onClickCb={() => {
                    dispatch(setUpdateWithheldIdModal(true));
                    dispatch(setSelectedStateReference(row));
                }}>Update Account Number</Button>
                <Loadable currentState={loadingState.state} loadingStates={[`${IRS_STATE_RESUBMIT_LOADING_STATES.FETCHING_VIEW_PDF_LIST_LOADING}-${EncryptedFormId}`]} messageMap={IRS_STATE_RESUBMIT_MESSAGE_MAP} isNewLoadable={true} isFullWidth={false}>
                    <Button type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER} onClickCb={() => dispatch(stateResubmitViewPDF({ reconFormId: row?.EncryptedFormId, formName: selectedForm?.value }))}><Icons familyName={'vec'} iconName={VEC_ICON_NAME.VIEW_ICON} /></Button>
                </Loadable>
            </div>
        },
    ];

    return (
        <>
            <div style={commonStyles.dropdownContainer}>
                <div style={commonStyles.selectDropdown}>
                    <Loadable
                        currentState={loadingState.state}
                        loadingStates={[IRS_STATE_RESUBMIT_LOADING_STATES.FETCHING_FORMS_LIST_LOADING]}
                        messageMap={IRS_STATE_RESUBMIT_MESSAGE_MAP}
                        isNewLoadable={true}
                        isFullWidth={false}
                    >
                        <SelectDropdown
                            name="selectedForm"
                            label="Form"
                            placeHolder="Select Form"
                            options={formList}
                            onSelectCb={(name, selectedOption) => {
                                dispatch(setSelectedForm(selectedOption));

                                if (selectedOption?.value) {
                                    queryParams.set(QUERY_PARAMS.FORM_ID, selectedOption?.value)
                                } else {
                                    queryParams.delete(QUERY_PARAMS.FORM_ID)
                                }
                                setQueryParams(queryParams);
                            }}
                            value={selectedForm}
                        />
                    </Loadable>
                    <Loadable
                        currentState={loadingState.state}
                        loadingStates={[IRS_STATE_RESUBMIT_LOADING_STATES.FETCHING_PAYERS_LIST_LOADING]}
                        messageMap={IRS_STATE_RESUBMIT_MESSAGE_MAP}
                        isNewLoadable={true}
                        isFullWidth={false}
                    >
                        <SelectDropdown
                            name="selectedPayer"
                            label="Payer"
                            placeHolder="Select Payer"
                            options={paginatedPayerList.slice(0, payerDropdownPagination.PageSize * (payerDropdownPagination.PageNumber))}
                            onDropdownTouchedToBottomCb={() => {
                                if (payerDropdownPagination.PageSize * (payerDropdownPagination.PageNumber) < paginatedPayerList?.length) {
                                    dispatch(setPayerDropdownPagination({ PageNumber: payerDropdownPagination.PageNumber + 1 }))
                                }
                            }}
                            onSelectCb={(name, selectedOption) => {
                                dispatch(setSelectedPayer(selectedOption));

                                if (selectedOption?.value) {
                                    queryParams.set(QUERY_PARAMS.PAYER_ID, selectedOption?.value)
                                } else {
                                    queryParams.delete(QUERY_PARAMS.PAYER_ID)
                                }
                                setQueryParams(queryParams);
                            }}
                            value={selectedPayer}
                        />
                    </Loadable>

                    <Loadable
                        currentState={loadingState.state}
                        loadingStates={[IRS_STATE_RESUBMIT_LOADING_STATES.FETCHING_YEARS_LIST_LOADING]}
                        messageMap={IRS_STATE_RESUBMIT_MESSAGE_MAP}
                        isNewLoadable={true}
                        isFullWidth={false}
                    >
                        <SelectDropdown
                            name="selectedTaxYear"
                            label="Tax Year"
                            placeHolder="Select Tax Year"
                            options={taxYearList}
                            onSelectCb={(name, selectedOption) => {
                                dispatch(setSelectedTaxYear(selectedOption));

                                if (selectedOption?.value) {
                                    queryParams.set(QUERY_PARAMS.TAX_YEAR, selectedOption?.value)
                                } else {
                                    queryParams.delete(QUERY_PARAMS.TAX_YEAR)
                                }
                                setQueryParams(queryParams);
                            }}
                            value={selectedTaxYear}
                        />
                    </Loadable>

                    <Button
                        onClickCb={() => {
                            if (selectedForm?.label && selectedPayer?.value && selectedTaxYear?.value) {
                                getGridRecords(1, paginationState?.PageSize)
                                dispatch(setPaginationState({ ...paginationState, PageNumber: 1 }));
                            } else {
                                dispatch(addNotifications({ heading: "Fields missing", variant: TOASTER_VARIANT.WARNING, message: "Please select form, payer and tax year" }))
                            }
                        }}>
                        Search
                    </Button>
                </div>
            </div>

            {stateResubmitGridData.length ? <div style={commonStyles.buttonContainer}>
                <Button type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} style={commonStyles.button} onClickCb={() => {
                    if (selectedStateResubmitGridData.length) {
                        dispatch(setDownloadAllPdfModal(true))
                    } else {
                        dispatch(addNotifications({ heading: "Fields missing", variant: TOASTER_VARIANT.WARNING, message: "Please select a form" }))
                    }
                }}>Download All PDF</Button>
            </div> : null}

            <Loadable
                currentState={loadingState.state}
                loadingStates={[IRS_STATE_RESUBMIT_LOADING_STATES.FETCHING_GRID_RECORDS_LOADING]}
                messageMap={IRS_STATE_RESUBMIT_MESSAGE_MAP}
                isNewLoadable={true}
                isFullWidth={false}
            >
                <RichGrid
                    selectable={true}
                    data={stateResubmitGridData}
                    columns={STATE_RESUBMIT_FORMS_COLUMN}
                    extractRowKey={(row) => row.FormId}
                    selectedRows={selectedStateResubmitGridData}
                    onSelectionChangeCallBack={(selectedData) => dispatch(setSelectedStateResubmitGridData(selectedData))}
                    paginationProps={{
                        skip: paginationState?.Skip,
                        take: paginationState?.PageSize,
                        takeOptions: ROW_SELECTION_OPTIONS,
                        total: paginationState?.total,
                        onChangeTakeCb: (newTake) => {
                            dispatch(setPaginationState({ ...paginationState, PageSize: newTake, PageNumber: 1, Skip: 0 }));
                            getGridRecords(1, newTake)
                        },
                        onChange: (take, skip) => {
                            dispatch(setPaginationState({ ...paginationState, PageSize: take, Skip: skip, PageNumber: Math.ceil((take + skip) / take) }))
                            getGridRecords(Math.ceil((take + skip) / take), take)
                        }
                    }}
                />
                <div style={styles.submitBtnContainer}>
                    <Button type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} style={{ ...commonStyles.button }} onClickCb={() => {
                        if (selectedStateResubmitGridData.length) {
                            if (isAccessAllowed(PAGE_PERMISSIONS.PAYMENTS, permissions)) {
                                let jsonData = selectedStateResubmitGridData.map(item => {
                                    let obj = {
                                        value: item?.StateReference ?? null
                                    };
                                    obj.key = (item?.StateReference ? true : false).toString();
                                    return obj;
                                });
                                dispatch(reSubmitSelectedFormsToState({
                                    data: {
                                        jsonPreferences: jsonData,
                                        FormTypeId: selectedForm?.FormId,
                                    }
                                }))
                            } else {
                                dispatch(setShowPaymentNotAllowedPopup(true))
                            }
                        } else {
                            dispatch(addNotifications({ heading: "Error", message: "Please select form details to submit to IRS", variant: TOASTER_VARIANT.WARNING }))
                        }
                    }} disabled={loadingState.state === IRS_STATE_RESUBMIT_LOADING_STATES.FETCHING_GRID_RECORDS_LOADING}>Submit</Button>
                </div>
            </Loadable>

            {updateWithheldIdModal &&
                <Popup
                    title="Enter Corrected Account Number"
                    isPopupOpen={updateWithheldIdModal}
                    childrenStyles={commonStyles.modalBody}
                    onCloseCb={() => {
                        dispatch(setUpdateWithheldIdModal(false))
                        dispatch(setSelectedStateReference({}));
                    }}
                >
                    <Loadable currentState={loadingState.state} loadingStates={[IRS_STATE_RESUBMIT_LOADING_STATES.UPDATE_WITHHELD_ID_LOADING]} messageMap={IRS_STATE_RESUBMIT_MESSAGE_MAP} isNewLoadable={true} isFullWidth={false}>
                        <TextInput placeHolder="" value={withheldIdText} onChangeCb={(e) => dispatch(setWithheldIdText(e.target.value))} />
                        <Button style={commonStyles.okButton} onClickCb={() => dispatch(updateStateWithHeldId({
                            CorrectedAccountNumber: withheldIdText,
                            StateReference: selectedStateReference?.StateReference,
                            formId: selectedForm?.value,
                            payerId: selectedPayer?.value,
                            taxYear: selectedTaxYear?.value,
                            paginationState,
                            formName: selectedForm?.label
                        }))}>Save</Button>
                    </Loadable>
                </Popup>
            }

            {downloadAllPdfModal && <DownloadAllPdf
                title="View/Print Form"
                isPopupOpen={downloadAllPdfModal}
                onCloseCb={() => dispatch(setDownloadAllPdfModal(false))}

                onSubmitCb={(selectedOption) => dispatch(downLoadStatePDFs({ payerName: selectedPayer?.LastName, formName: selectedForm?.FormName1, stateName: selectedOption?.value, taxYear: selectedTaxYear?.value, payerId: selectedPayer?.PayerDetailId, isRejected: true }))}

                options={selectedStateResubmitGridData.map(data => {
                    return { label: data?.State, value: data?.State }
                })}
            />}

        </>
    )
}